import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  AuthRepository,
  AuthRepositoryQuery,
} from '../../domain/repositories/auth.repository';
import { AuthRepositoryImpl } from './auth/auth.repository';
import { ListingsRepository } from '../../domain/repositories/listings.repository';
import { ListingsRepositoryImpl } from './listings/listings.repository';
import {
  CategoriesRepository,
  CategoriesRepositoryQuery,
} from '../../domain/repositories/categories.repository';
import { CategoriesRepositoryImpl } from './categories/categories.repositories';

export function provideRepositories(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AuthRepository, useClass: AuthRepositoryImpl },
    { provide: AuthRepositoryQuery, useExisting: AuthRepository },
    { provide: ListingsRepository, useClass: ListingsRepositoryImpl },
    { provide: CategoriesRepository, useClass: CategoriesRepositoryImpl },
    { provide: CategoriesRepositoryQuery, useExisting: CategoriesRepository },
  ]);
}
